import React, {useState} from "react";

import {
    ROUTES_INTEGRATIONS,
    ROUTES_INTEGRATIONS_METRC_LIST,
    ROUTES_INTEGRATIONS_ALPINEIQ_LIST,
    ROUTES_INTEGRATIONS_LEAFLOGIX_LIST,
    ROUTES_INTEGRATIONS_IDSCAN_LIST,
    ROUTES_INTEGRATIONS_DATABASE_SETUP
} from "../../utils/Constants.js";

import {Link} from "react-router-dom";

import Button from "@mui/material/Button/Button.js";
import {Box, Typography, Menu, MenuItem} from "@mui/material";
import {
    Settings as SettingsIcon,
} from "@mui/icons-material";

import {isEmpty} from "weed-js";
import {userIsNotLoggedIn} from "../../utils.js";


export const IntegrationsButton = ({loggedInUser, selectedOrganization, profile, userIsAdmin, setMainMenuAccordionExpanded}) => {
    const [integrationsAnchorEl, setIntegrationsAnchorEl] = useState(null);
    const integratiosIsOpen = Boolean(integrationsAnchorEl);

    if (
        userIsNotLoggedIn(loggedInUser) || 
        isEmpty(selectedOrganization) || 
        isEmpty(profile) || 
        !userIsAdmin
    ) {
        return "";
    }

    const handleIntegrationsClick = (event) => {
        setIntegrationsAnchorEl(event.currentTarget);
    };
    const handleIntegrationsClose = () => {
        setIntegrationsAnchorEl(null);
        setMainMenuAccordionExpanded(false);
    };

    return <Box>
        <Box className="menu-item">
            <Button onClick={handleIntegrationsClick}
                className={"navlink" + (ROUTES_INTEGRATIONS === location.pathname || ROUTES_INTEGRATIONS_METRC_LIST === location.pathname ? " selected" : "")}
                id="go-integrations">
                    <SettingsIcon/>
                    <Typography>Integrations</Typography>
            </Button>
        </Box>
        <Menu 
            open={integratiosIsOpen} 
            anchorEl={integrationsAnchorEl} 
            onClose={handleIntegrationsClose}
        >
            <MenuItem>
                <Link 
                    style={{width: "100%", height: "100%"}} 
                    to={ROUTES_INTEGRATIONS} 
                    className="navlink"
                    onClick={handleIntegrationsClose} 
                    id="go-integrations-setup"
                >
                    Setup
                </Link>
            </MenuItem>
            <MenuItem>
                <Link 
                    style={{width: "100%", height: "100%"}} 
                    to={ROUTES_INTEGRATIONS_LEAFLOGIX_LIST}
                    className="navlink" 
                    onClick={handleIntegrationsClose} 
                    id="go-leaflogix-integrations"
                >
                    Dutchie Integrations
                </Link>
            </MenuItem>
            <MenuItem>
                <Link 
                    style={{width: "100%", height: "100%"}} 
                    to={ROUTES_INTEGRATIONS_METRC_LIST}
                    className="navlink" 
                    onClick={handleIntegrationsClose} 
                    id="go-metrc-integrations"
                >
                    Metrc Integrations
                </Link>
            </MenuItem>
            <MenuItem>
                <Link 
                    style={{width: "100%", height: "100%"}} 
                    to={ROUTES_INTEGRATIONS_ALPINEIQ_LIST}
                    className="navlink" 
                    onClick={handleIntegrationsClose} 
                    id="go-alpineiq-integrations"
                >
                    AlpineIQ Integrations
                </Link>
            </MenuItem>
            <MenuItem>
                <Link 
                    style={{width: "100%", height: "100%"}} 
                    to={ROUTES_INTEGRATIONS_IDSCAN_LIST}
                    className="navlink" 
                    onClick={handleIntegrationsClose} 
                    id="go-id-scan-integrations"
                >
                    IdScan Integrations
                </Link>
            </MenuItem>
            {loggedInUser.is_superuser && <MenuItem>
                <Link 
                    style={{width: "100%", height: "100%"}} 
                    to={ROUTES_INTEGRATIONS_DATABASE_SETUP}
                    className="navlink" 
                    onClick={handleIntegrationsClose} 
                    id="go-legacy-database"
                >
                    Legacy Database Setup
                </Link>
            </MenuItem>}
        </Menu>
    </Box>;
};